import React from 'react';
import '../../styles/pay-with-product.scss';
import StackedBoxes from '../../../../Icons/icons/StackedBoxes';
import { formatCurrency } from '../../../../../utils/global';
import { useSelector } from 'react-redux';
import EditPen from '../../../../Icons/icons/EditPen';

const SelectedProductPreview = ({
  selectedProduct,
  allOptions,
  setIsSelectVariantOpen,
  getVariantDetails,
}) => {
  const { userDetails } = useSelector((s) => s.user);

  if (!selectedProduct.length)
    return (
      <div className="sl-product-preview sl-product-preview-ftux">
        <StackedBoxes />
        <span className="sl-product-preview-ftux-text">
          Selected products will appear here
        </span>
      </div>
    );

  return (
    <div className="sl-product-preview">
      {selectedProduct.map((item) => {
        let variantDetail;
        if (item?.variants) {
          variantDetail = getVariantDetails(item.id, item?.variants);
        }

        return (
          <div className="sl-product-preview-wrapper">
            <div className="sl-product-preview-container">
              <div className="sl-product-preview-content">
                <div className="sl-preview-product-image">
                  <img src={item?.image} alt="" />
                </div>
                <div className="sl-preview-product-text">
                  <div className="sl-preview-product-name">{item?.name}</div>
                  <div className="sl-preview-product-currency">
                    {variantDetail
                      ? formatCurrency(
                          Number(variantDetail?.price || item?.price),
                          userDetails?.defaultCurrency,
                        )
                      : '-'}
                  </div>
                </div>
              </div>
              <EditPen
                width={20}
                height={20}
                style={{ cursor: 'pointer' }}
                onClick={() => setIsSelectVariantOpen(true)}
              />
            </div>
            {item?.options?.length && (
              <div className="sl-product-preview-variant-wrapper">
                {item?.variants &&
                  item?.variants[0]?.option1 !== 'Default Title' &&
                  item?.options.map((option, index) => (
                    <p key={option?.id}>
                      <span className="sl-product-preview-variant-title">
                        {option?.name}:{' '}
                      </span>
                      <span className="sl-product-preview-variant-value">
                        {allOptions[item?.id]?.[`option${index + 1}`] ||
                          'N/A'}{' '}
                      </span>
                    </p>
                  ))}
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
};

export default SelectedProductPreview;
